import { normalizeNumber, normalizeString } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CORGI_SSR_CACHE_BUSTER = defineFcm('corgi_ssr_cache_buster')
	.asJson((value: unknown) => {
		try {
			return `${normalizeNumber(value)}`;
		} catch (e) {
			return normalizeString(value);
		}
	})
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'corgi SSR',
		description: `Used to cache-bust the SSR server cache.
			Can be used when an issue with caching is discovered, and a quick fix is needed until a new release of corgi.
			Value can be anything, it just needs to be different that the previous one`,
		import: false,
		template: 1,
	});
